module.exports = __webpack_public_path__ + "img/refle-right.4583634b.png";